import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FormikCheckbox } from '~src/commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { UpdateBooleanServerSettingNames } from '~src/settings/ServerApi/requests/serverSettings/UpdateBooleanServerSettingRequest';
import { ServerSettingsInstance } from '~src/settings/services/ServerSettings';

import { SettingsSection } from '../../../../components/common/SettingsSection';
import { ServerSettingsProps } from '../../server-settings/ReactServerSettings';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';

export const ADMIN_PROFILES_ENABLED_SECTION_NAME = 'adminProfilesEnabled';
export const ADMIN_PROFILES_SERVER_ENABLED_FIELD = 'settings.adminProfilesEnabled';

export const ADMIN_PROFILES_SECTION_TEST_ID = 'admin-profiles-setting-section';
export const ADMIN_PROFILES_CHECKBOX_TEST_ID = 'admin-profiles-enabled';

export type AdminProfilesSectionProps = ServerSettingsProps<'adminProfilesEnabled'>;


export function AdminProfilesSection(props: AdminProfilesSectionProps): React.ReactElement {
  return ((FeatureFlags.adminPermissionsEnabled) ? (
    <SettingsSection
        title={Messages.adminProfiles()}
        testId={ADMIN_PROFILES_SECTION_TEST_ID}
        description={Messages.adminProfilesDescription()}>
            <FormikCheckbox
                label={Messages.adminProfilesEnable()}
                name={ADMIN_PROFILES_SERVER_ENABLED_FIELD}
                testId={ADMIN_PROFILES_CHECKBOX_TEST_ID} />
    </SettingsSection>
  ) : (null as React.ReactElement));
}

export const AdminProfilesSectionSpecs = componentRegistryEntry({
  name: 'AdminProfilesSection',
  component: AdminProfilesSection,
  onSubmit: (settings) => {
    if(settings.adminProfilesEnabled !== undefined) {
      ServerSettingsInstance.updateBoolean(UpdateBooleanServerSettingNames.adminProfilesEnabled, settings.adminProfilesEnabled);
    }
  }
});
